module.exports = __webpack_public_path__ + "assets/b674d258d853bb202c901e199907793a.mp3";